import NumberOne from "../../images/icon/numberOne.svg";
import NumberTwo from "../../images/icon/numberTwo.svg";
import NumberThree from "../../images/icon/numberThree.svg";

const workItems = [
  {
    icon: NumberOne,
    title: "Define Your Ideal Candidate Profile",
    text: "Specialties, location, CPT/ICD codes, hospital affiliation, etc.",
  },
  {
    icon: NumberTwo,
    title: "Run Personalized Campaigns",
    text: "Display ads, video, LinkedIn, and conference targeting to generate awareness and engagement.",
  },
  {
    icon: NumberThree,
    title: "Receive NPI-Level Reports",
    text: "Monthly lists with full contact details—name, NPI, specialty, practice, and timestamped click data.",
  },
];

const WorkCard = ({ icon, title, text }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        justifyContent: "center",
        background: "#F4F9FF",
        maxWidth: "600px",
        padding: "4px",
        borderRadius: "10px",
      }}
    >
      <img
        style={{ minHeight: "100px", minWidth: "100px" }}
        src={icon}
        alt=""
      ></img>
      <div style={{ maxWidth: "480px" }}>
        <h2 style={{ fontSize: "22px", margin: "0" }}>{title}</h2>
        <p style={{ fontSize: "18px", margin: "0" }}>{text}</p>
      </div>
    </div>
  );
};

export const HowWorksSection = () => {
  return (
    <section className="section-sp2 px-10 ">
      <h1 className="text-center mb-40">How It Works</h1>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          alignItems: "center",
        }}
      >
        {workItems.map((item) => {
          return (
            <WorkCard icon={item.icon} title={item.title} text={item.text} />
          );
        })}
      </div>
    </section>
  );
};
